var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInvalidNumber = function SvgInvalidNumber(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 21H2L12 2.99 22 21zm1.87-.485.007-.003L12.862 2.48l-.009.005A1 1 0 0 0 12 2a1 1 0 0 0-.854.486l-.008-.006L1.124 20.513l.007.003A1 1 0 0 0 1 21a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1c0-.177-.05-.34-.13-.485M12 17a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-1-7c0 3 .5 5.5.5 5.5s0 .5.5.5.5-.5.5-.5.5-2.5.5-5.5c0-.5-.448-1-1-1s-1 .552-1 1"
  })));
};
export default SvgInvalidNumber;